import request from '@/utils/request.js'

export function getVedioOrderList(data){
    return request({
        url: 'invest/list',
        method: 'post',
        data
    })
}